import {useEffect, useState} from 'react'

export const useSpinnerVisibility = ({delay, isSpinning}) => {
	const [isVisible, setIsVisible] = useState(isSpinning && !delay)

	useEffect(() => {
		let delayTimeout

		if (!isSpinning) {
			setIsVisible(false)
		} else if (!delay) {
			setIsVisible(true)
		} else {
			delayTimeout = setTimeout(() => setIsVisible(true), delay)
		}

		return () => clearTimeout(delayTimeout)
	}, [delay, isSpinning])

	return isVisible
}
